import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  widthValue?: string;
  heightValue?: string;
  topValue?: string;
  leftValue?: string;
  rightValue?: string;
  rotationValue?: string;
  opacityValue?: number;
};

export const Root = styled.div`
    z-index: 150;
    height: ${(props: IRootProps) => props.heightValue ? props.heightValue : '100vh'};
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 0px;
    right: ${(props: IRootProps) => props.rightValue ? props.rightValue : '-100vw'};
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`;

export const PreviewsCanvas = styled.canvas`
    display: none;
`

export const ArrowIconContainer = styled.div`
    position: absolute;
    background-color: ${C.WHITE};
    border-radius: 20px;
    box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, 0.05);
    top: ${(props: IRootProps) => props.topValue ? props.topValue : '0px'};
    left: ${(props: IRootProps) => props.leftValue ? props.leftValue : '0px'};
`

export const RotateIcon = styled.div`
    transform: ${(props: IRootProps) => props.rotationValue ? props.rotationValue : '-100vw'};
    transition: transform 0.4s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`

export const BlurFrame = styled.div`
    height: 100%;
    width: ${(props: IRootProps) => props.widthValue ? props.widthValue : '100vw'};
    opacity: ${(props: IRootProps) => props.opacityValue ? props.opacityValue : 0};
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    background-color: #e6e9ec60;
`

export const Container = styled.div`
    height: 100%;
    width: ${(props: IRootProps) => props.widthValue ? props.widthValue : '-100vw'};
    flex: 1;
    background-color: white;
    display: flex;
    flex-direction: column;
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    overflow: auto;
`;

export const Header = styled.div`
    min-height: 63px;
    height: 63px;
    flex-grow: 0;
    margin: 0 0 28px;
    padding: 0 63px 0 63px;
    box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, 0.05);
    background-color: #fbfbfb;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Right = styled.div`
    display: flex;
    align-items: center;
`;

export const Title = styled.span`
    font-family: Roboto;
    font-size: 34px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
    margin-left: 50px;
`;

export const Left = styled.div`
    display: flex;
    align-items: center;
`;

export const LeftText = styled.span`
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: rgba(112, 112, 112, 0.5);
`;


export const Body = styled.div`
    display: flex;
    flex: 1;
`;

export const Column = styled.div`
    min-width: 694px;
    flex: 1;
    display: flex;
    flex-direction: column;
`;
